import React, { useState } from 'react';
import { useAuth, useIsMobile } from '@repo/common';
import InvoiceRow from './InvoiceRow';
import InvoiceDetailBottom from './InvoiceBottom';
import { ReactComponent as ChevronUpIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';
import { ReactComponent as MobileChevronUpIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-top.svg';

const InvoiceTable = ({ data, $isMobile }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'A';
  const [open, setOpen] = useState(true);

  if (!data) return null;

  const rows = (data.amounts ?? []).map((amt, index) => ({
    title: data.workshopTitles?.[index],
    status: data.statuses?.[index],
    amount: amt,
    date: data.workshopDates?.[index]?.[0],
    startTime: data.startTimes?.[index]?.[0],
    endTime: data.endTimes?.[index]?.[0],
    invoiceNumber: data.invoiceNumber,
    receiptUrl: data.receiptUrl,
    canceledSerialNumber: data.canceledSerialNumbers?.[index],
    holdExpiresAt: data.holdExpiresAtList?.[index],
    offerExpiresAt: data.offerExpiresAtList?.[index],
    bookingId: data.bookingIds?.[index],
    paymentId: data.paymentId,
    // 계좌이체 인보이스 여부 — 어드민 메뉴(이체 확인·수동 환불 확인) 분기
    paymentProvider: data.paymentProvider,
    currency: data.currency,
    refundStatus: data.refundStatus,
  }));

  if ($isMobile) {
    return (
      <div className='flex flex-col w-full'>
        <button
          onClick={() => setOpen((v) => !v)}
          className={`flex items-center justify-between w-full ${open && 'pb-[14px] border-b border-grayscale-gray01'}`}
        >
          <span className='typo-b16Strong text-text-primary'>
            Items ({rows.length})
          </span>
          <div className='size-[26px] flex items-center justify-center'>
            <MobileChevronUpIcon
              className={`text-icon-placeholder transition-transform ${open ? '' : 'rotate-180'}`}
            />
          </div>
        </button>

        {open && (
          <>
            <div className='flex flex-col'>
              {rows.map((item, index) => (
                <InvoiceRow
                  key={index}
                  index={index}
                  item={item}
                  isAdmin={isAdmin}
                  $isMobile
                />
              ))}
            </div>
            <InvoiceDetailBottom data={data} $isMobile />
          </>
        )}
      </div>
    );
  }

  return (
    <div className='flex flex-col w-full'>
      <div className='flex h-[40px] items-center w-full bg-surface-lightgray40 border-y border-grayscale-gray02 typo-b13 text-text-secondary text-center'>
        <div className='flex justify-center items-center gap-2.5 w-[120px]' />
        <div className='flex flex-col justify-center flex-1'>Item</div>
        <div className='flex flex-col justify-center w-[120px]'>Status</div>
        <div className='flex flex-col justify-center w-[100px]'>Amount</div>
        {isAdmin && (
          <div className='flex flex-col justify-center min-w-[40px] max-w-[80px] w-full' />
        )}
      </div>
      {rows.map((item, index) => (
        <InvoiceRow key={index} index={index} item={item} isAdmin={isAdmin} />
      ))}
    </div>
  );
};

export default InvoiceTable;
